exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search[data-v-bf1063d4] {\n  height: calc(100vh - 120px);\n  margin-top: 120px;\n  -webkit-transition: height, margin-top .3s ease;\n  -o-transition: height, margin-top .3s ease;\n  transition: height, margin-top .3s ease;\n}\n.header-compact .search[data-v-bf1063d4] {\n  height: calc(100vh - 76px);\n  margin-top: 76px;\n}\n", ""]);

// exports
